import * as React from "react";
import type { SVGProps } from "react";
const SvgRewardsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10.827 7.148 4.178-2.412 1.393 2.412h-5.571Zm-4 0 7.178-4.144a2 2 0 0 1 2.732.732l1.97 3.412H20a2 2 0 0 1 2 2v2c0 .553-.474.98-.959 1.245a2 2 0 0 0 0 3.511c.485.265.959.692.959 1.244v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V17c0-.552.475-.98.959-1.245a2 2 0 0 0 0-3.51C2.475 11.978 2 11.551 2 11V9.148a2 2 0 0 1 2-2h2.827Zm4.898 4.198a.29.29 0 0 1 .55 0l.584 1.716h1.85c.284 0 .4.367.165.53l-1.485 1.03.575 1.69a.29.29 0 0 1-.441.333L12 15.588l-1.523 1.057a.29.29 0 0 1-.44-.332l.574-1.69-1.486-1.032a.29.29 0 0 1 .166-.53h1.85l.584-1.715ZM20 10.684V9.148H4v1.387a3.999 3.999 0 0 1 0 6.93v1.683h16v-1.535a4 4 0 0 1 0-6.929Z"
    />
  </svg>
);
export default SvgRewardsIcon;
